import TabComponent from 'components/_parts/atoms/tab/Wla';
import { TabComponentTypes } from 'components/types/company';
import { useMemo, useState } from 'react';
import CompetencyLibrary from 'components/company/revamp/parts/setting/competencyLib/list';
import { useTranslation } from 'react-i18next';
import SkillGroup from 'components/company/revamp/parts/setting/skillComp/list';
import { TabCompetency } from '../dummySetting';
import { useFetchCompetencyGroup } from './useFetch';

function Competency() {
  const { t } = useTranslation();
  const dataTab = TabCompetency();
  const [tab, setTab] = useState(1);
  // useFetchCompetencyGroup(tab);
  const handleTab = (val: TabComponentTypes) => {
    setTab(val.id);
  };

  const MemoContent = useMemo(() => {
    switch (tab) {
      case 1:
        return <SkillGroup t={t} />;
      case 2:
        return <CompetencyLibrary t={t} tabComp={tab} />;

      default:
        return <SkillGroup t={t} />;
    }
  }, [tab]);
  return (
    <>
      <TabComponent
        tab={tab}
        dataTab={dataTab}
        handleClickTab={handleTab}
      />
      <div className="tw-mt-3">
        {MemoContent}
      </div>
    </>
  );
}

export default Competency;
